import AdvanceError from 'features/advance/screens/advanceStatusScreens/AdvanceError/AdvanceError';
import React from 'react';

export default function EmploymentInfoPage() {
  return <AdvanceError />;
}
